"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowProvider = exports.useWorkflowContext = void 0;
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const core_ui_1 = require("@sierralabs/core-ui");
const workflow_1 = require("@sierralabs/workflow");
const default_1 = __importDefault(require("./plugins/services/default"));
const default_2 = __importDefault(require("./plugins/transition-conditions/default"));
function match(a, b) {
    return a.taskTypeId && b.taskTypeId
        ? a.taskTypeId === b.taskTypeId
        : a.workflowId && b.workflowId
            ? a.workflowId === b.workflowId
            : false;
}
function getId(options) {
    if (options && typeof options === 'object') {
        const { workflowId, taskTypeId } = options;
        return taskTypeId
            ? { id: taskTypeId, type: 'taskType' }
            : workflowId
                ? { id: workflowId, type: 'workflow' }
                : undefined;
    }
    return options;
}
// use api.get instead of hook to avoid console errors related to
// updating parent component (WorkflowProvider) while rendering child components
function fetchWorkflowVersion(options, params = {}) {
    const idResult = getId(options);
    if (!idResult) {
        return;
    }
    const { id, type } = idResult;
    const url = type === 'workflow'
        ? `workflows/version/${id}`
        : `workflows/version/type/${id}`;
    const request = core_ui_1.api.get(url, params);
    const result = (0, core_ui_1.apiResolve)(request);
    return { request, result };
}
const WorkflowContext = (0, react_1.createContext)({
    workflows: [],
    servicePlugins: default_1.default,
    transitionConditionPlugins: default_2.default,
    find: () => undefined,
    findRef: () => undefined,
    findAsync: () => __awaiter(void 0, void 0, void 0, function* () { return undefined; }),
    load: () => __awaiter(void 0, void 0, void 0, function* () { return void {}; }),
    setError: () => void {}
});
function useWorkflowContext() {
    const context = (0, react_1.useContext)(WorkflowContext);
    if (!context) {
        throw new Error('useWorkflowContext must be used within the WorkflowProvider component.');
    }
    return context;
}
exports.useWorkflowContext = useWorkflowContext;
const WorkflowProvider = props => {
    const { children } = props;
    const { key } = (0, react_router_1.useLocation)();
    const [error, setErrorState] = (0, react_1.useState)();
    const [workflows, setWorkflows] = (0, react_1.useState)([]);
    const workflowsRef = (0, react_1.useRef)(workflows);
    const fetcher = (0, react_1.useMemo)(() => {
        return new core_ui_1.MultiFetch({
            fetch: payload => fetchWorkflowVersion(payload.options, payload.params),
            isEqual: (item, payload) => match(item.payload.options, payload.options)
        });
    }, []);
    // override default plugins
    const allServicePlugins = (0, react_1.useMemo)(() => {
        return props.servicePlugins || default_1.default;
    }, [props.servicePlugins]);
    const allTransitionConditionPlugins = (0, react_1.useMemo)(() => {
        return props.transitionConditionPlugins || default_2.default;
    }, [props.transitionConditionPlugins]);
    const addWorkflow = (0, react_1.useCallback)((workflowVersion) => {
        // check for exact workflow version object match
        // to avoid creating new workflow item objects
        const existing = workflowsRef.current.find(workflow => workflow.workflowVersion === workflowVersion);
        if (existing) {
            return existing;
        }
        const { taskTypeId } = workflowVersion.workflow || {};
        const newWorkflow = {
            taskTypeId,
            workflowVersion,
            workflowId: workflowVersion.workflowId,
            workflow: new workflow_1.Workflow(workflowVersion.config)
        };
        const copy = Array.from(workflowsRef.current);
        // check wrapper for existing taskType
        const index = copy.findIndex(workflow => {
            // check with workflowId if no taskType
            return taskTypeId
                ? workflow.taskTypeId === taskTypeId
                : workflow.workflowId === workflowVersion.workflowId;
        });
        if (index > -1) {
            copy.splice(index, 1, newWorkflow);
        }
        else {
            copy.push(newWorkflow);
        }
        workflowsRef.current = copy;
        setWorkflows(copy);
        return newWorkflow;
    }, []);
    const load = (0, react_1.useCallback)((options, params) => __awaiter(void 0, void 0, void 0, function* () {
        const item = yield fetcher.fetch({ options, params }, true);
        (item === null || item === void 0 ? void 0 : item.data) && addWorkflow(item.data);
    }), [fetcher, addWorkflow]);
    const find = (0, react_1.useCallback)((options) => {
        return workflows.find(workflow => {
            return match(options, workflow);
        });
    }, [workflows]);
    const findRef = (0, react_1.useCallback)((options) => {
        return workflowsRef.current.find(workflow => match(options, workflow));
    }, []);
    const findAsync = (0, react_1.useCallback)((options, params) => __awaiter(void 0, void 0, void 0, function* () {
        const item = findRef(options);
        if (item) {
            return item;
        }
        const loadedItem = yield fetcher.fetch({ options, params });
        return (loadedItem === null || loadedItem === void 0 ? void 0 : loadedItem.data) && addWorkflow(loadedItem.data);
    }), [fetcher, findRef, addWorkflow]);
    const setError = (0, react_1.useCallback)((newError) => {
        setErrorState(error => {
            return (newError === null || newError === void 0 ? void 0 : newError.message) !== (error === null || error === void 0 ? void 0 : error.message) ? newError : error;
        });
    }, []);
    const value = (0, react_1.useMemo)(() => {
        return {
            error,
            workflows,
            servicePlugins: allServicePlugins,
            transitionConditionPlugins: allTransitionConditionPlugins,
            find,
            findRef,
            findAsync,
            load,
            setError
        };
    }, [
        error,
        workflows,
        allServicePlugins,
        allTransitionConditionPlugins,
        find,
        findRef,
        findAsync,
        load,
        setError
    ]);
    // clear error when changing pages
    (0, react_1.useEffect)(() => {
        setError(undefined);
    }, [key, setError]);
    return (react_1.default.createElement(WorkflowContext.Provider, { value: value },
        children,
        react_1.default.createElement(core_ui_1.AppSnackbar, { severity: 'warning', open: !!error }, (error === null || error === void 0 ? void 0 : error.message) || 'An error occurred.')));
};
exports.WorkflowProvider = WorkflowProvider;
exports.default = exports.WorkflowProvider;
//# sourceMappingURL=Workflow.context.js.map